import React$1 from 'react';

const RightArrow = () => /*#__PURE__*/React$1.createElement("svg", {
  width: "47",
  height: "43",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 47 43"
}, /*#__PURE__*/React$1.createElement("path", {
  fillRule: "nonzero",
  d: "M24.741 0L47 21.5 24.741 43 21 39.386 36.928 24H0v-5h36.928L21 3.614z"
}));

export default RightArrow;
